import {ENDPOINT_PROGRAM} from 'common/endpoints';
import {commonJwtHeader} from 'common/utils';

const getProgramDetails = (token, params) => {
  return fetch(`${ENDPOINT_PROGRAM}programs/${params}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getProgramById = (token, id) => {
  return fetch(`${ENDPOINT_PROGRAM}${id}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getProgramsByStatus = (status) => {
  return fetch(`${ENDPOINT_PROGRAM}programs?status=${status}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};
const getProgramsbyIds = (token, programIds) => {
  return fetch(`${ENDPOINT_PROGRAM}programs/${programIds}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getAllPrograms = () => {
  return fetch(`${ENDPOINT_PROGRAM}all`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

export default {
  getProgramDetails,
  getProgramById,
  getProgramsByStatus,
  getProgramsbyIds,
  getAllPrograms,
};
